import { useDynamicConfig } from '@statsig/react-bindings';

import DexcomHero from './_heros/DexcomHero';
import GiveUsTheFingerHero from './_heros/GiveUsTheFingerHero';
import OR4Hero from './_heros/OR4Hero';
import SpringPriceDropHero from './_heros/SpringPriceDropHero';

const heroLookup: Record<string, () => React.JSX.Element> = {
  DexcomHero: () => <DexcomHero />,
  GiveUsTheFingerHero: () => <GiveUsTheFingerHero />,
  OR4Hero: () => <OR4Hero />,
  SpringPriceDropHero: () => <SpringPriceDropHero />,
};

type HeroType =
  | 'DexcomHero'
  | 'GiveUsTheFingerHero'
  | 'OR4Hero'
  | 'SpringPriceDropHero';

// If statsig misbehaves we will fallback to this
const FallbackHero = OR4Hero;

const HomeHeroGate = () => {
  const configHero = useDynamicConfig('home_hero').get(
    'hero',
    'OR4Hero',
  ) as HeroType;

  const Hero = heroLookup[configHero];

  return Hero ? <Hero /> : <FallbackHero />;
};

export default HomeHeroGate;
